import { ApplicationForm } from 'ui/components/buyer/patterns/ApplicationForm/ApplicationForm';
/**
 * 買い手企業プロフィール登録
 */
export const BuyerApplication: React.FC = () => {
    return <ApplicationForm />;
};
